<article
  class="tw-flex tw-flex-col tw-content-around tw-justify-around tw-p-8 tw-relative tw-bg-white tw-shadow-lg tw-rounded-lg tw-overflow-hidden tw-w-full tw-h-full tw-mx-auto">
  <!-- Close button -->
  <i class="far fa-times fa-lg tw-cursor-pointer tw-absolute tw-right-4 tw-top-3 tw-text-gray-500" (click)="close()"></i>

  <!-- Title -->
  <section class="tw-text-center tw-rounded-t-lg">
    <h1 class="tw-text-2xl tw-font-semibold tw-text-gray-800">{{ customTitle | translate }}</h1>
  </section>

  <!-- Description -->
  <section class="tw-px-8 tw-py-4 tw-text-center tw-text-gray-600 tw-text-lg tw-w-full"
    [mhTooltip]="tooltipDescription">
    <p class="tw-text-center" [innerHTML]="customDescription"></p>
  </section>

  <section class="tw-px-6 tw-py-4 tw-bg-white tw-mx-auto tw-w-full tw-overflow-y-auto tw-flex tw-flex-col md:tw-flex-row tw-border tw-border-gray-300 tw-rounded-lg">
    <mh-case-dismiss-modal #listBags
    [title]="''"
    [showButtons]="false"
    [reasons]="options"
    [OtherOptionAvailable]="false"
    [tooltipHighlight]="tooltipHighlight"
    class="tw-w-full md:tw-w-1/2"
    >
    </mh-case-dismiss-modal>

    <p class="tw-text-gray-600 tw-text-base tw-w-full md:tw-w-1/2 tw-text-left tw-flex tw-flex-col tw-justify-center" [innerHTML]="customOptionsDescription"></p>
  </section>

  <section class="tw-flex tw-gap-3 tw-justify-center tw-mt-4">
    <mh-core-lib-button
      *ngIf="showBackButton"
      [isSecondary]="true"
      [text]="'commons.back' | translate"
      [customClass]="'!tw-shadow-none !tw-px-2'"
      [textClass]="'tw-font-[Rubik] tw-text-sm'"
      (clicked)="goBack()"
    ></mh-core-lib-button>

    <mh-core-lib-button
      *ngIf="!showBackButton"
      [isSecondary]="true"
      [text]="'commons.cancel' | translate"
      [customClass]="'!tw-shadow-none !tw-px-2'"
      [textClass]="'tw-font-[Rubik] tw-text-sm'"
      (clicked)="close()"
    ></mh-core-lib-button>

    <mh-core-lib-button
      [isPrimary]="true"
      [isDisabled]="!selectedBag || !isAdmin"
      [mhTooltip]="!isAdmin ? ('followup.summary.whatsapp_modal.admin_required_tooltip' | translate) : ''"
      [text]="'followup.summary.data-rate.bags_modal.button' | translate"
      [customClass]="'!tw-shadow-none !tw-px-2'"
      [textClass]="'tw-font-[Rubik] tw-text-sm'"
      (clicked)="sendSelectedBag()"
    ></mh-core-lib-button>
  </section>

</article>
